import React, { useCallback } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { appLocalStore } from './stores/appLocalStore';
import { appSyncStore } from './stores/appSyncStore';
import { debugPanelStore } from './stores/debugPanelStore';
import ErrorsPanel from './components/errorsPanel';
import DebugPanel from './components/debugPanel';
import DebugToggle from './components/debugToggle';
import ConsolePanel from './components/consolePanel';
import ConsoleToggle from './components/consoleToggle';
import SplashScreen from './pages/splashScreen';
import UserSetupModalComponent from './pages/userSetupModalComponent';
import Lobby from './pages/lobby';
import JoinRoom from './pages/joinRoom';
import Waiting from './pages/waiting';
import Game from './pages/game';
import { PageType } from './types/navigation';
import { appConfig } from './config';
import ErrorPage from './pages/errorPage';
import { url } from 'inspector';
import { urlOptions } from './utils/urlOptions';

const AppContent = observer(() => {

  const consoleStore = appLocalStore.debug.console;

  const toggleDebug = useCallback(() => {
    debugPanelStore.toggleVisibility();
  }, []);

  const toggleConsole = useCallback(() => {
    consoleStore.toggleAction();
  }, []);

  const renderPage = () => {
    // If a game is active, always show the game page
    if (appSyncStore.gameActive) {
      // return <Game />;
      return <div className={`app-page app-page--game`}><Game /></div>
    }

    // Page component map
    const pageMap = new Map<PageType, React.ReactElement>([
      ['splash', <SplashScreen />],
      ['setup', <UserSetupModalComponent />],
      ['lobby', <Lobby />],
      ['join', <JoinRoom />],
      ['waiting', <Waiting />],
      ['game', <Game />],
    ]);

    const page = appLocalStore.currentPage;
    let pageString = page as string;

    <ErrorPage />
    let pageElement = pageMap.get(page);// || pageMap.get('error')!;
    if (!pageElement) {
      pageString = 'error';
      pageElement = <ErrorPage />;
    }

    return <div className={`app-page app-page--${pageString}`}>{pageElement}</div>;
  };

  return (
    <div className="m-0 p-0">
      <ErrorsPanel />
      {renderPage()}
      {urlOptions.debug && (
        <>
          <DebugPanel />
          <DebugToggle onClick={toggleDebug} isActive={debugPanelStore.isVisible} />
          <ConsolePanel />
          <ConsoleToggle onClick={toggleConsole} isActive={consoleStore.visible} />
        </>
      )}
    </div>
  );
});

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
